import { Component } from 'react';
import { Home, RefreshCw, LogIn } from 'lucide-react';
import { Button } from './ui/button';

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught:', error, errorInfo);
  }

  handleReload = () => {
    window.location.reload();
  };

  handleGoHome = () => {
    window.location.href = '/';
  };

  handleLogin = () => {
    localStorage.removeItem('auth_token');
    localStorage.removeItem('user');
    window.location.href = '/login';
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-muted/30 flex items-center justify-center p-4">
          <div className="max-w-md w-full bg-white rounded-2xl shadow-lg p-8 text-center space-y-6">
            <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto">
              <span className="text-2xl">!</span>
            </div>
            <div>
              <h2 className="text-xl font-bold text-foreground mb-2">Algo correu mal</h2>
              <p className="text-sm text-muted-foreground">
                Ocorreu um erro inesperado. Os teus dados estao seguros. Tenta recarregar a pagina.
              </p>
            </div>
            <div className="flex flex-col gap-3">
              <Button onClick={this.handleReload} className="w-full" data-testid="error-reload-btn">
                <RefreshCw className="w-4 h-4 mr-2" />
                Recarregar Pagina
              </Button>
              <Button variant="outline" onClick={this.handleLogin} className="w-full" data-testid="error-login-btn">
                <LogIn className="w-4 h-4 mr-2" />
                Iniciar Sessao
              </Button>
              <Button variant="ghost" onClick={this.handleGoHome} className="w-full" data-testid="error-home-btn">
                <Home className="w-4 h-4 mr-2" />
                Pagina Inicial
              </Button>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
